// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getRoles as listRolesAPI,
    getRole as getRoleAPI,
    getRoleTopbar as getRoleTopbarAPI,
    addRole as addRoleAPI,
    updateRole as updateRoleAPI,
    deleteRole as deleteRoleAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { rolesApiResponseError, rolesApiResponseSuccess } from './actions';
import { RolesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getRole({ payload: { id } }) {
    try {
        const response = yield call(getRoleAPI, id);
        const role = response.data.data;
        yield put(rolesApiResponseSuccess(RolesActionTypes.GET_ROLE, role));
    } catch (error) {
        yield put(rolesApiResponseError(RolesActionTypes.GET_ROLE, error));
    }
}

function * getRoleTopbar({ payload: { id } }) {
    try {
        const response = yield call(getRoleTopbarAPI, id);
        const roleTopbar = response.data.data;
        yield put(rolesApiResponseSuccess(RolesActionTypes.GET_ROLE_TOPBAR, roleTopbar));
    } catch (error) {
        yield put(rolesApiResponseError(RolesActionTypes.GET_ROLE_TOPBAR, error));
    }
}

/**
 * List contactos
 */
function* listRoles() {
    try {
        const response = yield call(listRolesAPI);
        const listaRoles = response.data.data;
        yield put(rolesApiResponseSuccess(RolesActionTypes.LIST_ROLES, listaRoles));
    } catch (error) {
        yield put(rolesApiResponseError(RolesActionTypes.LIST_ROLES, error));
    }
}

function* addRole({ payload: role }) {
    try {
        const response = yield call(addRoleAPI, { ...role })
        const roleItem = response.data.data
        yield put(rolesApiResponseSuccess(RolesActionTypes.ADD_ROLE, roleItem))
    } catch (error) {
        yield put(rolesApiResponseError(RolesActionTypes.ADD_ROLE, error))
    }
}

function* updateRole({ payload: role }) {
    try {
        const response = yield call(updateRoleAPI, { ...role })
        const roleItem = response.data.data
        yield put(rolesApiResponseSuccess(RolesActionTypes.UPDATE_ROLE, roleItem))
    } catch (error) {
        yield put(rolesApiResponseError(RolesActionTypes.UPDATE_ROLE, error))
    }
}

function* deleteRole({ payload: { id } }) {
    try {
        const response = yield call(deleteRoleAPI, id)
        const roleItem = response.data.id
        yield put(rolesApiResponseSuccess(RolesActionTypes.DELETE_ROLE, roleItem))
    } catch (error) {
        yield put(rolesApiResponseError(RolesActionTypes.DELETE_ROLE, error))
    }
}


export function* watchGetRole(): any {
    yield takeEvery(RolesActionTypes.GET_ROLE, getRole);
}

export function* watchGetRoleTopbar(): any {
    yield takeEvery(RolesActionTypes.GET_ROLE_TOPBAR, getRoleTopbar);
}

export function* watchListRoles(): any {
    yield takeEvery(RolesActionTypes.LIST_ROLES, listRoles);
}

export function* watchAddRole(): any {
    yield takeEvery(RolesActionTypes.ADD_ROLE, addRole);
}

export function* watchUpdateRole(): any {
    yield takeEvery(RolesActionTypes.UPDATE_ROLE, updateRole);
}
export function* watchDeleteRole(): any {
    yield takeEvery(RolesActionTypes.DELETE_ROLE, deleteRole);
}


function* rolesSaga(): any {
    yield all([
        fork(watchGetRole),
        fork(watchGetRoleTopbar),
        fork(watchListRoles),
        fork(watchAddRole),
        fork(watchUpdateRole),
        fork(watchDeleteRole),
    ]);
}

export default rolesSaga;
